var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g({directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:_vm.classes,staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.title}},_vm.$listeners),[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }